import React, { memo, useCallback, useEffect, useState } from 'react';
import {
  Button,
  Card,
  Checkbox,
  Image,
  InputNumber,
  Row,
  Tabs,
  Typography,
  List,
  Col,
  Divider,
} from 'antd';
import {
  AssetCatalogResponse,
  ParAssetCatalogOptionResponse,
  ParAssetCatalogServiceResponse,
} from '../../services/assetconfig';
import { CATALOG_IMG_URL } from '../../utils/config';
import AssetCatalogItemDetailsModal from './AssetCatalogItemDetailsModal';
import { PlusOutlined } from '@ant-design/icons';
import { toCurrency } from 'utils/utils';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ModalController from 'components/ModalController';
import AssetCatalogDetailsModal from 'pages/Configuration/AssetCatalog/AssetCatalogDetailsModal';
import { debounce } from 'lodash';

type AssetCatalogItemProps = {
  item: AssetCatalogResponse;
  onSelect: (
    item: AssetCatalogResponse,
    nbasset: number,
    selectedServices: ParAssetCatalogServiceResponse[],
    selectedOption: ParAssetCatalogOptionResponse[],
    fromCatalogMulticomponents: boolean,
    assetCatalogServices?: ParAssetCatalogServiceResponse[],
    assetCatalogOptions?: ParAssetCatalogOptionResponse[]
  ) => void;
};
const { TabPane } = Tabs;

const AssetCatalogItem = (props: AssetCatalogItemProps) => {
  const { item, onSelect } = props;

  console.log('item', item);

  const [detailsVisible, setDetailsVisible] = useState(false);

  const [loadingbtn, setLoadingBtn] = useState(false);

  const [selectedServices, setSelectedServices] = useState<
    ParAssetCatalogServiceResponse[]
  >([]);

  const [selectedOption, setselectedOption] = useState<
    ParAssetCatalogOptionResponse[]
  >([]);

  const [activeKey, setActiveKey] = useState('1');

  const imageSrc = CATALOG_IMG_URL + item.assetpictureurl;

  const closeDetails = useCallback(() => {
    setDetailsVisible(false);
  }, []);

  const openDetails = useCallback(() => {
    setDetailsVisible(true);
  }, []);
  const [nbasset, setnbasset] = useState(1);
  const [assetnetamountWithOptions, setAssetnetamountWithOptions] = useState(
    item.assetnetamount
  );
  const [assettaxamountWithOptions, setAssettaxamountWithOptions] = useState(
    item.assettaxamount
  );
  const [assetgrossamountWithOptions, setAssetgrossamountWithOptions] =
    useState(item.assetgrossamount);

  useEffect(() => {}, [selectedServices, selectedOption]);

  const handelselectAssetCat = debounce(() => {
    onSelect(
      {
        ...item,
        entityAddAttribut: item?.entityAddAttribut,
        assetnetamount: assetnetamountWithOptions,
        assettaxamount: assettaxamountWithOptions,
        assetgrossamount: assetgrossamountWithOptions,
        assetmulticomponents:
          selectedOption.length > 0 ? true : item?.assetmulticomponents,
      },
      nbasset,
      selectedServices,
      selectedOption,
      item?.assetmulticomponents,
      item.assetCatalogServices,
      item.assetCatalogOptions
    );
    setTimeout(() => {
      setLoadingBtn(false);
    }, 2000);
  }, 500);

  return (
    <Card style={{ alignContent: 'center' }} className="AssetCatalogItem">
      <Tabs
        activeKey={activeKey}
        centered
        onChange={(e) => {
          setActiveKey(e);
        }}
      >
        <TabPane tab="Asset" key="1" animated>
          <Row justify="center">
            <Card
              style={{ alignContent: 'center', width: 290, padding: 0 }}
              className="AssetCatalogItem"
              bordered={false}
              cover={
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <Image
                        preview={{ visible: false }}
                        src={imageSrc}
                        width={150}
                        height={150}
                        onClick={(e) => {
                          setVisible(true);
                          e.stopPropagation();
                        }}
                      />
                      <AssetCatalogDetailsModal
                        title={item.assetlabel}
                        catalogid={item.catalogid}
                        visible={visible}
                        onCancel={() => setVisible(false)}
                      />
                    </>
                  )}
                </ModalController>
              }
              actions={[
                <Typography.Link key={1}>
                  <Button
                    icon={<PlusOutlined />}
                    type="primary"
                    loading={loadingbtn}
                    onClick={() => {
                      setLoadingBtn(true);
                      handelselectAssetCat();
                    }}
                  >
                    <GetLabel label="add" />
                  </Button>
                </Typography.Link>,
                <InputNumber
                  key={2}
                  size="large"
                  value={nbasset}
                  min={1}
                  max={100}
                  bordered={false}
                  onChange={(nb) => setnbasset(nb!)}
                />,
              ]}
            >
              <Divider />
              <Typography.Link key={1} onClick={openDetails}>
                <Card.Meta
                  title={`${item.assetlabel}`}
                  description={`${toCurrency(
                    assetnetamountWithOptions,
                    item.currcode
                  )}`}
                  style={{ textAlign: 'center', fontSize: 20 }}
                />
              </Typography.Link>
            </Card>
          </Row>
        </TabPane>

        <TabPane tab="Options" key="3">
          <Row justify="center">
            <Card
              style={{ alignContent: 'center', width: 290, padding: 0 }}
              className="AssetCatalogItem"
              bordered={false}
              cover={
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <Image
                        preview={{ visible: false }}
                        src={imageSrc}
                        width={150}
                        height={150}
                        onClick={(e) => {
                          setVisible(true);
                          e.stopPropagation();
                        }}
                      />
                      <AssetCatalogDetailsModal
                        title={item.assetlabel}
                        catalogid={item.catalogid}
                        visible={visible}
                        onCancel={() => setVisible(false)}
                      />
                    </>
                  )}
                </ModalController>
              }
              actions={[
                <Typography.Link key={1}>
                  <Button
                    icon={<PlusOutlined />}
                    type="primary"
                    loading={loadingbtn}
                    onClick={() => {
                      setLoadingBtn(true);
                      handelselectAssetCat();
                    }}
                  >
                    <GetLabel label="add" />
                  </Button>
                </Typography.Link>,
                <InputNumber
                  key={2}
                  size="large"
                  value={nbasset}
                  min={1}
                  max={100}
                  bordered={false}
                  onChange={(nb) => setnbasset(nb!)}
                />,
              ]}
            >
              {item?.assetCatalogOptions?.length > 0 && (
                <List
                  size="small"
                  style={{ width: '100%' }}
                  dataSource={item?.assetCatalogOptions ?? []}
                  renderItem={(e) => (
                    <List.Item>
                      <Checkbox
                        value={e.optvalue}
                        onChange={(a) => {
                          if (a.target.checked) {
                            setselectedOption([...selectedOption, e]);
                            setAssetnetamountWithOptions(
                              assetnetamountWithOptions + e.optnetamount
                            );
                            setAssettaxamountWithOptions(
                              assettaxamountWithOptions + e.opttaxamount
                            );
                            setAssetgrossamountWithOptions(
                              assetgrossamountWithOptions + e.optgrossamount
                            );
                          } else {
                            let items = selectedOption.filter(
                              (i) => i.optvalue !== a.target.value
                            );

                            setAssetnetamountWithOptions(
                              assetnetamountWithOptions - e.optnetamount
                            );
                            setAssettaxamountWithOptions(
                              assettaxamountWithOptions - e.opttaxamount
                            );
                            setAssetgrossamountWithOptions(
                              assetgrossamountWithOptions - e.optgrossamount
                            );

                            setselectedOption(items);
                          }
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Col>
                            {`${e.optcodelabel} 
                              : 
                              ${e.optvaluelabel ? e.optvaluelabel : ''} 
                              : 
                              ${toCurrency(e.optnetamount, item.currcode)}`}
                          </Col>
                        </div>
                      </Checkbox>
                    </List.Item>
                  )}
                />
              )}
              <Divider />
              <Typography.Link key={1} onClick={openDetails}>
                <Card.Meta
                  title={`${item.assetlabel}`}
                  description={`${toCurrency(
                    assetnetamountWithOptions,
                    item.currcode
                  )}`}
                  style={{ textAlign: 'center', fontSize: 20 }}
                />
              </Typography.Link>
            </Card>
          </Row>

          <Row style={{ padding: '1px 1px' }}>
            {/* {?.map((e, index) => (
              <Col span={24} key={index}>
                <Checkbox value={e.optvalue}>
                 
                </Checkbox>
              </Col>
            ))} */}
          </Row>
        </TabPane>

        <TabPane tab="Services" key="2">
          <Row justify="center">
            <Card
              style={{ alignContent: 'center', width: 290, padding: 0 }}
              className="AssetCatalogItem"
              bordered={false}
              cover={
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <Image
                        preview={{ visible: false }}
                        src={imageSrc}
                        width={150}
                        height={150}
                        onClick={(e) => {
                          setVisible(true);
                          e.stopPropagation();
                        }}
                      />
                      <AssetCatalogDetailsModal
                        title={item.assetlabel}
                        catalogid={item.catalogid}
                        visible={visible}
                        onCancel={() => setVisible(false)}
                      />
                    </>
                  )}
                </ModalController>
              }
              actions={[
                <Typography.Link key={1}>
                  <Button
                    icon={<PlusOutlined />}
                    type="primary"
                    loading={loadingbtn}
                    onClick={() => {
                      setLoadingBtn(true);
                      handelselectAssetCat();
                    }}
                  >
                    <GetLabel label="add" />
                  </Button>
                </Typography.Link>,
                <InputNumber
                  key={2}
                  size="large"
                  value={nbasset}
                  min={1}
                  max={100}
                  bordered={false}
                  onChange={(nb) => setnbasset(nb!)}
                />,
              ]}
            >
              {item?.assetCatalogServices?.length > 0 && (
                <List
                  size="small"
                  style={{ width: '100%', marginTop: 10, marginBottom: 30 }}
                  dataSource={item?.assetCatalogServices ?? []}
                  renderItem={(e) => (
                    <List.Item>
                      <Checkbox
                        value={e.servcode}
                        onChange={(a) => {
                          if (a.target.checked) {
                            setSelectedServices([...selectedServices, e]);
                          } else {
                            let items = selectedServices.filter(
                              (i) => i.servcode !== a.target.value
                            );
                            setSelectedServices(items);
                          }
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Col>
                            {`${e.servlabel}
                              :
                              ${toCurrency(e.servfixedamount, item.currcode)}`}
                          </Col>
                        </div>
                      </Checkbox>
                    </List.Item>
                  )}
                />
              )}
              <Divider />
              <Typography.Link key={1} onClick={openDetails}>
                <Card.Meta
                  title={`${item.assetlabel}`}
                  description={`${toCurrency(
                    assetnetamountWithOptions,
                    item.currcode
                  )}`}
                  style={{ textAlign: 'center', fontSize: 20 }}
                />
              </Typography.Link>
            </Card>
          </Row>
        </TabPane>
      </Tabs>

      <AssetCatalogItemDetailsModal
        currcode={item.currcode}
        item={item}
        visible={detailsVisible}
        onCancel={closeDetails}
      />
    </Card>
  );
};

export default memo(AssetCatalogItem);
